import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import { useLayoutEffect, useState } from 'react';

function Header({ setContactUsOpened }: { setContactUsOpened: (s: boolean) => void }) {
  const [visible, setVisible] = useState(false);
  const isMobile = useMediaQuery('(max-width:800px)');

  useLayoutEffect(() => {
    function updateScroll() {
      setVisible(window.scrollY === 0);
    }
    window.addEventListener('scroll', updateScroll);
    updateScroll();
    return () => window.removeEventListener('resize', updateScroll);
  }, []);

  const navItems = [
    {
      title: 'Advances',
      anchor: 'advances_anchor',
    },
    {
      title: 'Features',
      anchor: 'features_anchor',
    },
    // {
    //   title: 'Testimonials',
    //   anchor: 'testimonials_anchor',
    // },
    {
      title: 'Contacts',
      anchor: 'footer_anchor',
    },
  ];

  return (
    <Box
      sx={{
        height: isMobile ? '55px' : '74px',
        position: 'fixed',
        zIndex: 99,
        top: 0,
        background: visible ? undefined : 'rgba(40, 40, 40, 0.80)',
        backdropFilter: visible ? undefined : 'blur(15px)',
        transition: 'all 0.5s ease',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          maxWidth: '1350px',
          width: '100%',
          margin: 'auto',
          padding: '0 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <img
          width={isMobile ? 84 : 130}
          style={{ cursor: 'pointer' }}
          onClick={() => {
            const target = document.getElementById('header_anchor');
            if (target) {
              target.scrollIntoView({ behavior: 'smooth' });
            }
          }}
          src="/images/logo_new.svg"
          alt="logo"
        ></img>
        {!isMobile && (
          <Box
            sx={{
              display: 'flex',
              gap: '40px',
            }}
          >
            {navItems.map((item, index) => (
              <Typography
                key={index}
                onClick={() => {
                  const target = document.getElementById(item.anchor);
                  if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                sx={{
                  fontSize: '16px',
                  fontFamily: 'RedHat600',
                  color: '#B5B5B5',
                  lineHeight: 'normal',
                  transition: 'all 0.5s ease',
                  cursor: 'pointer',
                  '&:hover': {
                    color: '#FFF',
                  },
                }}
              >
                {item.title}
              </Typography>
            ))}
          </Box>
        )}
        <Button
          onClick={() => {
            setContactUsOpened(true);
          }}
          variant="contained"
          sx={{
            backgroundColor: '#247BFE',
            borderRadius: isMobile ? '8px' : '12px',
            padding: isMobile ? '8px 15px' : '12px 20px',
            fontSize: isMobile ? '14px' : '16px',
            fontFamily: 'RedHat600',
            color: '#fff',
            textTransform: 'initial',
            boxShadow: 'none',
            lineHeight: 'normal',
          }}
        >
          Contact us
        </Button>
      </Box>
    </Box>
  );
}

export default Header;
